import { getCookie } from '../../../../assets/frontend/js/utils/cookie'

const SELECTOR = "input[type='checkbox'].darkmode-toggle"

const colorSchemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

function setTheme(theme: string, setCookie = false) {
  document.documentElement.dataset.bsTheme = theme
  for (const control of document.querySelectorAll<HTMLInputElement>(SELECTOR)) {
    control.checked = theme === 'dark'
  }
  if (setCookie) {
    document.cookie = `icf-theme=${theme}; path=/; max-age=31536000; samesite=strict`
  }
}

function handleSystemColorChange(evt: MediaQueryListEvent) {
  setTheme(evt.matches ? 'dark' : 'light')
}

function attachSystemColorChange() {
  colorSchemeMediaQuery.addEventListener('change', handleSystemColorChange)
}

function detachSystemColorChange() {
  colorSchemeMediaQuery.removeEventListener('change', handleSystemColorChange)
}

function init() {
  for (const control of document.querySelectorAll<HTMLInputElement>(SELECTOR)) {
    control.addEventListener('change', () => {
      detachSystemColorChange()
      setTheme(control.checked ? 'dark' : 'light', true)
    })
  }

  const cookieValue = getCookie('icf-theme')

  if (cookieValue) {
    // if the theme toggle has been used, the cookie is now set
    // and we use this changed preference
    setTheme(cookieValue)
  } else {
    // if the theme toggle hasn't been used yet, use the system preferences color-scheme
    setTheme(colorSchemeMediaQuery.matches ? 'dark' : 'light')
    // listen for color-scheme changes, while the site is open
    attachSystemColorChange()
  }
}

if (document.documentElement.dataset.ytThemesEnabled === 'true') {
  init()
}
